
<template>
  <el-container class="page">
      <div class="header">
        <div class="text"><span>标准数据库 / </span><span>科研代码管理</span></div>
        <div class="search">
          <el-input placeholder="请输入项目名称" prefix-icon="el-icon-search" v-model="filterText" class="header-search"
            size="small" @change="searchNode">
          </el-input>
          <div style="margin-left: 10px">归属研究院：</div>

          <el-select size="small" v-model="from.researchInstituteName" slot="prepend" placeholder="请选择研究院大类"
            @change="searchSelectchange">
            <el-option :label="item.label" :value="item" v-for="item in department" :key="item.departmentCode">
            </el-option>
          </el-select>
          <div style="margin-left: 10px">学科类别：</div>

          <el-select size="small" v-model="from.searchOneSelect" slot="prepend" placeholder="请选择一级类别"
            @focus="focusSearchOneSelect" @change="changeSearchOneSelect">
            <el-option :label="item.categoryName" :value="item" v-for="item in searchSelectOneList" :key="item.id">
            </el-option>
          </el-select>
          <div style="width: 10px"></div>
          <el-select size="small" v-model="from.searchTwoSelect" slot="append" placeholder="请选择二级类别"
            @focus="focusSearchTwoSelect" @change="changeSearchTwoSelect">
            <el-option :label="item.categoryName" :value="item" v-for="(item, index) in searchSelectTwoList"
              :key="index"></el-option>
          </el-select>
          <div class="btn">
            <el-button size="small" @click="resetSearchAll">重置</el-button>
            <el-button size="small" style="background: #1a7bfc; color: #fff" @click="searchAll">搜索</el-button>
          </div>
        </div>
      </div>
      <el-main class="content">
        <div class="left">
          <div class="left-header">
            <div class="header-solid"></div>
            <div>科研代码类型</div>
          </div>
          <el-scrollbar ref="scrollbar" style="height: 94%;" wrap-style="overflow-x:hidden;">

            <el-tree ref="tree" v-if="showTree" :data="treeData" :props="defaultProps" @node-click="handleNodeClick"
              @node-expand="nodeExpand" highlight-current :filter-node-method="filterNode">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ data.categoryName }}</span>
                <span v-if="!data.children" class="node-btn">
                  <el-button type="text" size="mini" style="color:#1a7bfc" @click.stop="() => editRowData(node, data)">
                    编辑
                  </el-button>
                  <span style="margin:0 10px;color:#333">|</span>
                  <el-button type="text" size="mini" style="color:#1a7bfc"
                    @click.stop="() => removeRowData(node, data)">
                    删除
                  </el-button>
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
        <div class="right">
          <div class="right-header">
            <div class="header-solid"></div>
            <div>{{ showAdd ? '新增学科' : '编辑学科' }}</div>
          </div>
          <el-scrollbar style="height: calc(100% - 30px);">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm"
              size="small">
              <el-form-item label="学科名称：" prop="categoryName">
                <el-input v-model="ruleForm.categoryName" clearable></el-input>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="学科代码：" prop="categoryCode">
                    <el-input v-model="ruleForm.categoryCode" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="归属研究院：" prop="researchInstitute">
                    <el-select v-model="ruleForm.researchInstitute" placeholder="请选择归属研究院" @change="changeSelect"
                      :disabled="!showAdd" style="width: 100%">
                      <el-option :label="item.label" :value="item.departmentCode" v-for="(item, index) in department"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="归属一级学科：">
                    <el-select placeholder="请选归属一级学科" v-model="ruleForm.departmentOneName" @focus="focusOneSelect"
                      @change="changeOneSelect" style="width: 100%">
                      <el-option :label="item.categoryName" :value="item" v-for="(item, index) in departmentOneList"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="归属一级学科代码：">
                    <el-input v-model="ruleForm.departmentOneCode" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="归属二级学科：">
                    <el-select placeholder="请选择归属二级学科" @focus="focusTwoSelect" @change="changeTwoSelect"
                      v-model="ruleForm.departmentTwoName" style="width: 100%">
                      <el-option :label="item.categoryName" :value="item" v-for="(item, index) in departmentTwoList"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="归属二级学科代码：">
                    <el-input v-model="ruleForm.departmentTwoCode" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="归属三级学科：" prop="">
                    <el-select v-model="ruleForm.departmentThreeName" placeholder="请选择归属三级学科" @focus="focusThreeSelect"
                      @change="changeThreeSelect" style="width: 100%">
                      <el-option :label="item.categoryName" :value="item" v-for="(item, index) in departmentThreeList"
                        :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="归属三级学科代码：">
                    <el-input v-model="ruleForm.departmentThreeCode" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="是否启用：" prop="status">
                <el-radio-group v-model="ruleForm.status">
                  <el-radio :label="false">是</el-radio>
                  <el-radio :label="true">否</el-radio>

                </el-radio-group>
              </el-form-item>
              <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" rows="4" v-model="ruleForm.remark"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button style="width: 110px" v-if="!showAdd" @click="cancel">取消</el-button>
                <el-button style="width: 110px" @click="resetForm">重置</el-button>
                <el-button style="background: #1a7bfc; color: #fff; width: 110px" @click="submitForm('ruleForm')">保存
                </el-button>
              </el-form-item>
            </el-form>
          </el-scrollbar>
        </div>
      </el-main>
  </el-container>
</template>

<script>
import {
  addCategory,
  updateCategory,
  deleteCategory,
  getTreeData,
  getClassification,
  getCategoryDetail
} from "../../api";
export default {
  data() {
    var validateCode = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error('学科代码不能为空'))
      // }
      let regx = /^[a-z0-9]+$/i;
      if (regx.test(value)) {
        callback();
      } else {
        callback(new Error("请输入数字和英文"));
        this.ruleForm.categoryCode = "";
        return;
      }
    };
    return {
      filterText: "",
      showTree: true, // 重新加载树
      from: {
        search: "",
        researchInstitute: "",
        selectOne: "",
        searchOneSelect: "",
        searchTwoSelect: ""
      },
      searchSelectOneList: [],
      searchSelectTwoList: [],
      department: [
        { label: "国自然基金委", departmentCode: 1 },
        { label: "科技部", departmentCode: 2 }
      ],
      departmentOneList: [],
      departmentTwoList: [],
      departmentThreeList: [],
      treeData: [],
      defaultProps: {
        children: "children",
        label: "categoryName"
      },
      radio: false,
      showAdd: true,

      ruleForm: {
        categoryName: "",
        categoryCode: "",
        departmentOneCode: "",
        researchInstitute: "",
        researchInstituteName: "",

        departmentOneName: "",
        departmentOneCode: "",
        departmentTwoName: "",
        departmentTwoCode: "",
        departmentThreeName: "",
        departmentThreeCode: "",
        status: false
      },
      rules: {
        categoryName: [
          { required: true, message: "学科名称不能为空", trigger: "blur" }
        ],
        categoryCode: [
          { required: true, message: "学科代码不能为空", trigger: "blur" },
          { validator: validateCode, trigger: "change" }
        ],
        researchInstitute: [
          { required: true, message: "请选择归属研究院", trigger: "blur" }
        ]
      },
      parentId: "", //

      twoId: "",
      threeId: "",
      researchInstitute: ""
    };
  },
  watch: {
    // twoId: {
    //   handler(newVal, oldVal) {
    //   },
    //   immediate: true,
    // },
    // threeId: {
    //   handler(newVal, oldVal) {
    //   },
    // immediate: true,
    // },
  },
  created() {
    this.init();
  },
  methods: {
    // 查询节点
    searchNode(val) {
      this.$refs.tree.filter(val);
    },
    resetSearchAll() {
      this.from.parentId = "";
      this.searchSelectTwoList = [];
      this.searchSelectOneList = [];

      this.from = {};
      this.filterText = "";
    },
    searchAll() {
      let obj;
      obj = this.filterText;
      if (this.from.researchInstituteName) {
        obj = this.from.researchInstituteName;
      }

      if (this.from.searchOneSelect) {
        obj = this.from.searchOneSelect;
      }
      if (this.from.searchTwoSelect) {
        obj = this.from.searchTwoSelect;
      }

      this.$refs.tree.filter(obj);
      // obj = ''
    },
    /**
     * 获取首页数据
     */
    init() {
      // type= 1.药品；2.检验；3.检查；4.治疗；5.科研; 6.运动
      getTreeData({ type: 5 }).then(res => {
        if (res.code == 0) {
          // this.treeData = res.data[0].treeVO
          let arr = [];
          res.data.forEach(el => {
            let obj = {};
            obj.children = el.treeVO;
            obj.categoryName = el.name;
            arr.push(obj);
          });
          this.treeData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 取消
     */
    cancel() {
      this.twoId = "";
      this.showAdd = true;
      this.$refs.ruleForm.resetFields();
      this.threeId = "";
      // debugger

      this.ruleForm = {
        categoryName: "",
        categoryCode: "",
        researchInstitute: "",
        departmentOneCode: "",
        departmentOneName: "",
        departmentOneCode: "",
        departmentTwoName: "",
        departmentTwoCode: "",
        departmentThreeName: "",
        departmentThreeCode: "",
        status: false,
        remark: ""
      };

      // this.ruleForm.researchInstitute = this.researchInstitute

      // this.ruleForm.status = false
    },
    /**
     * 编辑数据
     */
    editRowData(e, data) {
      this.showAdd = false;

      getCategoryDetail({ id: data.id }).then(res => {
        let data = res.data;
        let obj = {
          categoryCode: data.categoryCode,
          categoryName: data.categoryName,
          departmentOneCode: data.firstCategoryCode,
          departmentOneName: data.firstCategoryName,
          departmentTwoName: data.secondCategoryName,
          departmentTwoCode: data.secondCategoryCode,
          departmentThreeCode: data.thirdCategoryCode,
          departmentThreeName: data.thirdCategoryName,
          researchInstitute: data.researchInstitute,
          status: data.status,
          remark: data.remark,
          id: data.id,
          parentId: data.parentId,
          firstCategoryId: data.firstCategoryId,
          secondCategoryId: data.secondCategoryId
        };
        this.ruleForm = obj;
        this.twoId = obj.firstCategoryId;
        this.threeId = obj.secondCategoryId;
        this.researchInstitute = obj.researchInstitute;
      });
    },
    /**
     * 删除数据
     */
    removeRowData(node, data) {
      node.parent.loaded = false;
      node.parent.expand();
      this.$confirm("确定要删除当前科研数据吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        customClass: "message-confirm-style"
      })
        .then(() => {
          deleteCategory(data.id).then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });

              // this.showTree = false
              setTimeout(res => {
                this.init();
                // this.showTree = true
              }, 1000);
              this.ruleForm.status = false;
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleNodeClick() {},

    /**
     * 搜索研究院分类数据
     */
    searchSelectchange(e) {
      this.from.searchOneSelect = "";
      this.from.searchTwoSelect = "";
      this.from.researchInstitute = e.departmentCode;
      this.from.researchInstituteName = e.label;
    },
    /**
     * 搜索一级分类数据
     */
    changeSearchOneSelect(e) {
      this.from.searchOneSelect = e.categoryName;
      // e 为查找二级分类的parentId
      this.from.parentId = e.id;
    },
    focusSearchOneSelect() {
      if (!this.from.researchInstitute) {
        this.$message("请选择归属研究院!");
        return;
      }
      let query = {
        type: 5,
        researchInstitute: this.from.researchInstitute,
        parentId: 0 // 一级
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.searchSelectOneList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 搜索二级分类数据
     */
    focusSearchTwoSelect() {
      if (!this.from.parentId) {
        this.$message("请选择一级学科类别!");
        return;
      }
      let query = {
        type: 5,
        researchInstitute: this.from.departmentCode,
        parentId: this.from.parentId // 一级
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.searchSelectTwoList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeSearchTwoSelect(e) {
      this.from.searchTwoSelect = e.categoryName;
    },
    // 改变大类
    changeSelect(e) {
      this.ruleForm.departmentOneName = "";
      this.ruleForm.departmentOneCode = "";

      this.ruleForm.departmentTwoName = "";
      this.ruleForm.departmentTwoCode = "";

      this.ruleForm.departmentThreeName = "";
      this.ruleForm.departmentThreeCode = "";
      this.ruleForm.researchInstitute = e;
      // if (!this.ruleForm.researchInstitute) {
      //   this.$message('请选择归属研究院!')
      //   return
      // }
      let query = {
        type: 5,
        researchInstitute: this.ruleForm.researchInstitute,
        parentId: 0 // 一级
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.departmentOneList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * 获取分类数据
     */

    focusOneSelect() {
      if (!this.ruleForm.researchInstitute) {
        this.$message("请选择归属研究院!");
        this.departmentOneList = [];
        return;
      } else {
        // if(!this.showAdd){

        let query = {
          type: 5,
          researchInstitute: this.ruleForm.researchInstitute,
          parentId: 0 // 一级
        };
        getClassification(query).then(res => {
          if (res.code == 0) {
            this.departmentOneList = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
      }

      // }
    },
    /**
     * 改变一级选项
     */
    changeOneSelect(e) {
      this.ruleForm.departmentOneName = e.categoryName;
      this.ruleForm.departmentOneCode = e.categoryCode;

      this.parentId = e.id;

      this.twoId = e.id;

      this.ruleForm.departmentTwoName = "";
      this.ruleForm.departmentTwoCode = "";

      this.ruleForm.departmentThreeName = "";
      this.ruleForm.departmentThreeCode = "";
      this.threeId = "";
      // if(this.threeId = ''){
      //   this.twoId = ''
      // }

      this.focusTwoSelect();
    },

    focusTwoSelect() {
      if (!this.twoId) {
        this.$message("请选择上一级");
        this.departmentTwoList = [];
        return;
      }
      // if(!this.showAdd){
      //   if(!(this.twoId)){
      //   this.$message('暂无二级数据')
      //   return
      // }
      //   // this.twoId = this.ruleForm.firstCategoryId
      // }else{
      //   if(!this.twoId){
      //   this.$message('请选择上一级')
      //   return
      // }

      // }
      let query = {
        type: 5,
        researchInstitute: this.ruleForm.researchInstitute,
        parentId: this.twoId // 一级
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.departmentTwoList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeTwoSelect(e) {
      // this.ruleForm.departmentTwoCode = e
      this.ruleForm.departmentTwoName = e.categoryName;
      this.ruleForm.departmentTwoCode = e.categoryCode;

      this.parentId = e.id;

      this.threeId = e.id;
      this.ruleForm.departmentThreeName = "";
      this.ruleForm.departmentThreeCode = "";
      // this.twoId = ''

      this.focusThreeSelect();
    },

    // 获取三级选择
    focusThreeSelect() {
      this.departmentThreeList = [];
      if (!this.threeId) {
        this.$message("请选择上一级");
        return;
      }

      let query = {
        type: 5,
        researchInstitute: this.ruleForm.researchInstitute,
        parentId: this.threeId // 级
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.departmentThreeList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    changeThreeSelect(e) {

      this.parentId = e.id;

      this.parentId = e.id;
      this.ruleForm.departmentThreeCode = e.categoryCode;
      this.ruleForm.departmentThreeName = e.categoryName;
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // alert('submit!')

          let query = {
            categoryCode: this.ruleForm.categoryCode,
            categoryName: this.ruleForm.categoryName,
            researchInstitute: this.ruleForm.researchInstitute,
            type: 5,
            status: this.ruleForm.status,
            remark: this.ruleForm.remark,
            parentId: this.parentId || 0,
            id: this.ruleForm.id
          };
          if (this.showAdd) {
            addCategory(query).then(res => {
              if (res.data) {
                this.$message.success("保存成功！");
                this.$refs.ruleForm.resetFields();
                this.ruleForm = {
                  status: false
                };
                // this.ruleForm.status = false

                this.parentId = "";

                this.twoId = "";
                this.threeId = "";
                this.departmentOneList = [];
                this.departmentTwoList = [];
                this.departmentThreeList = [];
                setTimeout(() => {
                  this.init();
                }, 100);
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let editQuery = {
              categoryCode: this.ruleForm.categoryCode,
              categoryName: this.ruleForm.categoryName,
              researchInstitute: this.ruleForm.researchInstitute,
              type: 5,
              status: this.ruleForm.status,
              remark: this.ruleForm.remark,
              parentId: this.parentId ? this.parentId : this.ruleForm.parentId,
              id: this.ruleForm.id
            };
            updateCategory(editQuery).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "成功!"
                });
                setTimeout(res => {
                  this.init();
                }, 1000);
                this.showAdd = true;
                // 解决验证提示错误
                this.$refs.ruleForm.resetFields();
                // this.ruleForm={
                //   status:false
                // }
                this.ruleForm = {
                  status: false
                };

                this.parentId = "";

                this.twoId = "";
                this.threeId = "";
                this.departmentOneList = [];
                this.departmentTwoList = [];
                this.departmentThreeList = [];
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    nodeExpand(node, data, arr) {
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.twoId = "";
      this.threeId = "";
      if (this.showAdd) {
        this.ruleForm = {
          categoryName: "",
          categoryCode: "",
          departmentOneCode: "",
          researchInstitute: "",
          researchInstituteName: "",

          departmentOneName: "",
          departmentOneCode: "",
          departmentTwoName: "",
          departmentTwoCode: "",
          departmentThreeName: "",
          departmentThreeCode: "",
          status: false,
          id: this.ruleForm.id
        };
      } else {
        this.ruleForm = {
          categoryName: "",
          categoryCode: "",
          departmentOneCode: "",
          researchInstitute: this.researchInstitute,
          // researchInstituteName: '',

          departmentOneName: "",
          departmentOneCode: "",
          departmentTwoName: "",
          departmentTwoCode: "",
          departmentThreeName: "",
          departmentThreeCode: "",
          status: false,
          id: this.ruleForm.id
        };
      }

      // this.ruleForm.status = false
    },
    filterNode(value, data, node) {
      // 如果什么都没填就直接返回
      if (!value) return true;
      // 如果传入的value和data中的label相同说明是匹配到了
      if (data.categoryName.indexOf(value) !== -1) {
        return true;
      }
      // 否则要去判断它是不是选中节点的子节点
      return this.checkBelongToChooseNode(value, data, node);
    },
    // 判断传入的节点是不是选中节点的子节点
    checkBelongToChooseNode(value, data, node) {
      const level = node.level;
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false;
      }
      // 先取当前节点的父节点
      let parentData = node.parent;
      // 遍历当前节点的父节点
      let index = 0;
      while (index < level - 1) {
        // 如果匹配到直接返回

        if (parentData.data.categoryName.indexOf(value) !== -1) {
          return true;
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent;
        index++;
      }
      // 没匹配到返回false
      return false;
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
}

.header {
  background: #fff;
  padding: 20px;
  .text {
    margin-bottom: 20px;
    color: #333333;
    font-size: 14px;
    span:nth-child(2) {
      color: #000000;
    }
    span:nth-child(1) {
      color: #666666;
    }
  }
  .header-search {
    width: 200px;
  }
  .search {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .btn {
    margin-left: 10px;
  }
}
.content {
  display: flex;
  padding: 20px;
  .left {
    flex: 0.3;
    margin-right: 16px;
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    .left-header {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      display: flex;
      align-items: center;
      margin-bottom: 27px;
      .header-solid {
        width: 4px;
        height: 15px;
        background: #1a7bfc;
        margin-right: 10px;
      }
    }

    .custom-tree-node {
      position: relative;
      width: 100%;

      .node-btn {
        position: absolute;
        right: 0;
        margin-top: -4px;
        margin-left: 10px;
        margin-right: 15px;
      }
    }
  }
  .right {
    flex: 0.7;
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    overflow: hidden;

    .right-header {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .header-solid {
        width: 4px;
        height: 15px;
        background: #1a7bfc;
        // border-radius: 2px;
        margin-right: 10px;
      }
    }
  }
}
</style>